//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  auth: false,
  layout: 'front-page',
  data () {
    return {
      activeFaq: null,
      faqs: [
        {
          id: 1,
          question: 'Bagaimana cara mendapatkan aplikasi Century Marketplace?',
          answer:
            '<p>Download aplikasi Century Marketplace di Play Store pada Smartphone anda  masing-masing.</p><ul><li>HEHE</li><li>HOHO</li></ul>'
        },
        {
          id: 2,
          question:
            'Apakah aplikasi Century Marketplace tersedia di Apps store?',
          answer: '<p>Untuk saat ini belum, hanya di Play Store (Android).</p>'
        },
        {
          id: 3,
          question:
            'Saya tidak bisa checkout barang di keranjang, apa masalahnya?',
          answer:
            '<p>Sebelum melakukan transaksi, anda harus daftar sebagai member Century Marketplace terlebih dahulu.</p>'
        },
        {
          id: 4,
          question: 'Bagaimana cara menjadi member Century Marketplace?',
          answer: `<ul><li>Pada halaman beranda, klik garis tiga pada kiri atas</li>
          <li>Pilih Registrasi</li>
          <li>Pilih Belum</li>
          <li>Masukkan data-data sesuai dengan pertanyaan</li>
          <li>Masukkan nomor handphone anda yang aktif, karena akan ada kode OTP yang dikirimkan ke nomor handphone yang telah didaftarkan pada halaman sebelumnya.</li></ul>`
        },
        {
          id: 5,
          question:
            'Saya sudah punya kartu member Century, apakah ini bisa dipakai sebagai member pada Apps Century Marketplace?',
          answer: `<ul><li>Ya, bisa</li> 
          <li>Pada halaman beranda, klik garis tiga pada kiri atas</li>
          <li>Pilih Registrasi</li>
          <li>Pilih Sudah</li>
          <li>Masukkan nomor handphone anda yang aktif, karena akan ada kode OTP yang dikirimkan ke nomor handphone yang telah didaftarkan pada halaman sebelumnya.</li></ul>`
        },
        {
          id: 6,
          question:
            'Apakah berbeda benefit menggunakan member lama dengan member baru?',
          answer:
            '<p>Member lama maupun member baru mendapatkan benefit yang sama</p>'
        },
        {
          id: 7,
          question:
            'Bagaimana jika lupa password pada saat ingin login?Apakah berbeda benefit menggunakan member lama dengan member baru?',
          answer: `<ul><li>Pada halaman beranda, klik garis tiga pada kiri atas</li>
          <li>Pilih Login</li>
          <li>Pilih Lupa Password</li>
          <li>Masukkan Nomor handphone yang terdaftar pada member</li>
          <li>Klik Kirim OTP</li>
          <li>Anda akan menerima kode OTP, silahkan masukkan dan tekan Verifikasi</li></ul>`
        },
        {
          id: 8,
          question:
            'Bagaimana cara menambahkan alamat untuk pengiriman barang?',
          answer: `<ul><li>Pada halaman beranda, klik garis tiga pada kiri atas</li>
          <li>Pilih Profil Anda</li>
          <li>Pilih Daftar Alamat</li>
          <li>Pilih Tambah Alamat Baru</li>
          <li>Masukkan alamat baru sesuai dengan yang dibutuhkan</li></ul>`
        },
        {
          id: 9,
          question: 'Bagaimana cara mengubah nomor handphone?',
          answer: `<ul><li>Pada halaman beranda, klik garis tiga pada kiri atas</li>
          <li>Pilih Profil Anda</li>
          <li>Klik Edit (logo pensil)</li>
          <li>Ubah nomor handphone sesuai dengan kebutuhan</li>
          <li>Klik Simpan</li></ul>`
        },
        {
          id: 10,
          question: 'Apa kegunaan metode transfer pada profile?',
          answer:
            '<p>Ketika melakukan cancel order, maka dana refund akan segera di transfer sesuai metode refund yang didaftarkan tersebut.</p>'
        },
        {
          id: 11,
          question: 'Bagaimana cara mencari produk?',
          answer: `<ul><li>Pada halaman beranda, klik kotak pencarian di paling atas (gambar kaca pembesar)</li>
          <li>Ketik nama produk yang anda inginkan</li>
          <li>Klik produk yang anda inginkan</li></ul>`
        },
        {
          id: 12,
          question: 'Bagaimana cara membeli produk?',
          answer:
            '<p>Setelah memilih produk yang diinginkan, tentukan jumlah produk yang ingin dibeli, setelah itu klik tombol “Beli” pada bagian kiri bawah.</p>'
        },
        {
          id: 13,
          question: 'Bagaimana cara memasukkan produk ke dalam keranjang?',
          answer:
            '<p>Setelah memilih produk yang diinginkan, tentukan jumlah produk yang ingin dimasukkan ke dalam keranjang, setelah itu klik tombol “+ Keranjang” pada bagian kanan bawah.</p>'
        },
        {
          id: 14,
          question: 'Apa saja metode pembayaran?',
          answer:
            '<p>Metode pembayaran saat ini bisa melalui OVO ataupun Virtual Account dari berbagai Bank.</p>'
        },
        {
          id: 15,
          question:
            'Apakah ada batas waktu pembayaran ketika sudah tertera metode pembayaran?',
          answer:
            '<p>Batas waktu untuk metode pembayaran yang sudah dipilih adalah 2 jam setelah pesanan dibuat</p>'
        },
        {
          id: 16,
          question:
            'Apa yang terjadi jika pembayaran sudah lewat dari 2 jam sejak pesanan dibuat?',
          answer:
            '<p>Pemesanan barang akan dibatalkan, silahkan buat pesanan baru dan dibayar dalam kurun waktu 2 jam.</p>'
        },
        {
          id: 17,
          question:
            'Apa yang harus dilakukan jika ingin membeli produk tapi sudah lewat dari batas waktu pembayaran?',
          answer:
            '<p>Silahkan buat pesanan baru dan dibayar dalam kurun waktu 2 jam.</p>'
        },
        {
          id: 18,
          question:
            'Apa yang terjadi dengan pesanan yang sebelumnya, ketika kita membuat pesanan baru?',
          answer:
            '<p>Pesanan yang lama akan dibatalkan jika belum ada pembayaran</p>'
        },
        {
          id: 19,
          question: 'Apa ekspedisi yang digunakan pada saat pengiriman?',
          answer:
            '<p>Pengiriman saat ini hanya menggunakan ekspedisi J&T Express</p>'
        },
        {
          id: 20,
          question: 'Apakah ada gratis ongkir?',
          answer: '<p>Mohon maaf, saat ini belum tersedia gratis ongkir</p>'
        },
        {
          id: 21,
          question: 'Berapa lama proses pengemasan produk?',
          answer:
            '<p>Member lama maupun member baru mendapatkan benefit  yang sama</p>'
        },
        {
          id: 22,
          question: 'Berapa lama pengiriman produk?',
          answer:
            '<p>Pengiriman produk disesuaikan dengan lokasi penerima produk, setelah produk diserahkan dari pihak Century kepada pihak ekspedisi</p>'
        },
        {
          id: 23,
          question:
            'Apa yang harus dilakukan jika ingin melakukan komplain dan melampirkan bukti detail pesanan beserta video unboxing ?',
          answer:
            '<p>video unboxing dan screenshot detail pesanan dapat dikirim ke Customer Service Century Marketplace melalui WA ke nomor 081119113338</p>'
        }
      ]
    }
  },
  methods: {
    setActive (index) {
      if (this.activeFaq === index) {
        this.activeFaq = null
      } else {
        this.activeFaq = index
      }
    }
  }
}
